import { Badge } from '@mui/material';

export default function TabIconBadge({ value, icon, ...props }) {
    const formatValue = (val) => {
        if (val >= 1000000) {
            return Math.floor(val / 1000000) + 'm';
        }
        if (val >= 10000) {
            return Math.floor(val / 1000) + 'k';
        }
        return val;
    };

    return (
        <Badge badgeContent={formatValue(value)} max={9999} showZero
            sx={{
                '& .MuiSvgIcon-root': {
                    position: 'relative',
                    right: 10,
                },
                '& .MuiBadge-badge': {
                    right: value < 10 ? 0 : (value < 100 ? -3 : (value < 1000 ? -6 : -10)),
                    top: 12,
                    backgroundColor: 'gray',
                    color: 'white',
                },
                '.Mui-selected & .MuiBadge-badge': {
                  backgroundColor: (theme) => theme.palette.primary.main,
                  color: 'white',
                },
            }} {...props}>
            {icon}
        </Badge>
    );
}